/* Requires jQuery + Slick */
(function () {
  /* Utils */

  function waitFor(predicate, cb, tries = 160, delay = 50) {
    if (predicate()) return cb();
    if (tries <= 0) return console.warn('[home-collection] deps not ready');
    setTimeout(() => waitFor(predicate, cb, tries - 1, delay), delay);
  }

  const norm = (v) => String(v || '').trim().toLowerCase();

  /* AS SEEN ON (mobile only) */

  function initAsSeenOn($) {
    const el = document.querySelector('.as_seen_on_wrap');
    if (!el || screen.width >= 1200) return;

    const $wrap = $('.as_seen_on_wrap');
    if (typeof $wrap.infiniteslide !== 'function') return;

    // prevent double init
    if ($wrap.data('inited')) return;
    $wrap.data('inited', true);

    $wrap.infiniteslide({
      speed: 30,
      direction: 'left',
      pauseonhover: true,
      responsive: true,
      clone: 2,
    });
  }

  /* BEST SELLERS */

  function initBestSellers($) {
    const $slider = $('.bs_products');
    if (!$slider.length) return;

    const SLICK_SETTINGS = {
      slidesToShow: 4,
      slidesToScroll: 4,
      infinite: false,
      arrows: false,
      dots: false,
      responsive: [
        { breakpoint: 1000, settings: { slidesToShow: 3, slidesToScroll: 3 } },
        { breakpoint: 576, settings: { slidesToShow: 2, slidesToScroll: 2 } },
      ],
    };

    /* category helper */

    function getItemCategory($el) {
      // category can be on card or inside it
      const $item = $el.hasClass('best_sellers_item')
        ? $el
        : $el.find('.best_sellers_item').first();

      return (
        $item.attr('data-category') ||
        $item.data('category') ||
        $el.find('[data-category]').first().attr('data-category') ||
        ''
      );
    }

    /* cache original items */

    // cache original cards once
    if (!window.__BS_CACHE__) {
      const baseItems = $slider.hasClass('slick-initialized')
        ? $slider.find('.slick-slide:not(.slick-cloned)').children()
        : $slider.children();

      window.__BS_CACHE__ = baseItems
        .map(function () {
          return {
            cat: norm(getItemCategory($(this))),
            node: this.cloneNode(true),
          };
        })
        .get();
    }

    /* rebuild slider */

    function rebuildSlider(items) {
      if ($slider.hasClass('slick-initialized')) {
        try {
          $slider.slick('unslick');
        } catch (_) {}
      }

      $slider.empty();
      items.forEach((x) => $slider.append(x.node.cloneNode(true)));

      if ($slider.children().length) {
        $slider.slick(SLICK_SETTINGS);
      }

      bindCardRedirects();
    }

    /* render by category */

    function renderCategory(category) {
      const wanted = norm(category);

      const items =
        wanted && wanted !== 'all'
          ? window.__BS_CACHE__.filter((x) => x.cat === wanted)
          : window.__BS_CACHE__;

      rebuildSlider(items);

      console.log('[home-collection] render:', wanted, items.length);
    }

    /* card redirect */

    function bindCardRedirects() {
      document.querySelectorAll('.best_sellers_item').forEach((el) => {
        if (el.dataset.bsBound) return;
        el.dataset.bsBound = '1';

        el.addEventListener('click', () => {
          if (el.dataset.redirectUrl) {
            window.location.href = el.dataset.redirectUrl;
          }
        });
      });
    }

    /* tabs */
    
    // delegation — safe after DOM rebuild
    $(document)
      .off('click.bsTabs')
      .on('click.bsTabs', '.best_sellers_nav_item', function () {
        const filter = $(this).data('filter');

        $('.best_sellers_nav_item').removeClass('active');
        $(this).addClass('active');

        renderCategory(filter);
        navSeparatorAdjust();
      });

    /* separator */

    function navSeparatorAdjust() {
      const items = document.querySelectorAll('.best_sellers_nav_item');
      const sep = document.querySelector('.bs_nav_separator');
      if (!sep || !items.length) return;

      const first = items[0];
      const last = items[items.length - 1];

      sep.style.left = first.offsetLeft + first.offsetWidth / 2 + 'px';
      sep.style.width =
        last.offsetLeft +
        last.offsetWidth / 2 -
        (first.offsetLeft + first.offsetWidth / 2) +
        'px';
    }

    if (!window.__BS_SEP_BOUND__) {
      window.__BS_SEP_BOUND__ = true;
      window.addEventListener('resize', navSeparatorAdjust);
    }

    navSeparatorAdjust();

    /* initial tab */

    const firstTab =
      $('.best_sellers_nav_item.active').data('filter') ||
      $('.best_sellers_nav_item').first().data('filter');

    renderCategory(firstTab || 'all');

    console.log('[home-collection] best sellers ready ✅');
  }

  /* COLOR REDIRECT */

  function initColorRedirect() {
    const wrap = document.querySelector('.color_picker_redirect_wrap');
    if (!wrap) return;

    wrap.querySelectorAll('.color_swatch_item').forEach((el) => {
      if (el.dataset.bound) return;
      el.dataset.bound = '1';

      el.addEventListener(
        'click',
        (e) => {
          e.preventDefault();
          e.stopPropagation();
          if (el.dataset.url) window.location.href = el.dataset.url;
        },
        true
      );
    });
  }

  /* BOOT */

  function boot() {
    waitFor(
      () => window.jQuery && window.jQuery.fn && window.jQuery.fn.slick,
      () => {
        const $ = window.jQuery;

        $(function () {
          initAsSeenOn($);
          initBestSellers($);
          initColorRedirect();

          // Shopify may re-render section
          setTimeout(() => initBestSellers($), 300);
          setTimeout(() => initBestSellers($), 1000);
        });
      }
    );
  }

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', boot)
    : boot();
})();